import React from "react";

export const AnalyticsIcon = () => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-macaw-ui-candidate
  >
    <path
      d="M3.333 17.5v-5.833h3.334V17.5H3.333Zm5-8.333v8.333h3.334V9.167H8.333Zm5-5.834v14.167h3.334V3.333h-3.334Z"
      fill="currentColor"
    />
  </svg>
);
